import React from 'react';
import './experienceCard.css';
import {shopIcon, scheduleIcon} from '../../../../../utils/icons';

const formatDateRange = (startDate, endDate) => {
  if (!startDate && !endDate) return 'No especificado';
  
  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    return d.getFullYear();
  };

  const start = formatDate(startDate);
  const end = formatDate(endDate);
  
  if (start && end) {
    return `${start} - ${end}`;
  } else if (start) {
    return `${start} - Presente`;
  } else if (end) {
    return `Hasta ${end}`;
  }
  
  return 'No especificado';
};

const ExperienceCard = ({ data }) => {

 
  return (
    <div className="experience-card__item-container"> 
      <div className="experience-card__col-1">
        <div className='experience-card__info-container'>
          <label>POSICION</label>
          <p><strong>{data.role}</strong></p>
        </div>
      </div>   
      <div className="experience-card__col-2">
         <div className="experience-card__icon-info-container">
           {shopIcon}
           <div className='experience-card__info-container'>
              <p>{data.companyName}</p>
              <label>EMPRESA</label>
           </div>
         </div>
        
        <div className="experience-card__icon-info-container">
         {scheduleIcon}
         <div className='experience-card__info-container'>
           <p>{formatDateRange(data.startDate, data.endDate)}</p>
          <label>PERIODO</label>
         </div>
        </div>
      </div>
      <div className='experience-card__col-3'>
        <p>
          {data.description}
        </p>
      </div>
    </div>
  );
};

export default ExperienceCard;

